module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/bold-ae3d9008fc4a8b8d5f20c9396878765a.svg";